import { Chip } from '@mui/material';
import { Datagrid, List, SearchInput, TextField, useRecordContext, type RaRecord } from 'react-admin';

/**
 * Organisations: producers on a product, and the buyer on a B2B order.
 *
 * This screen exists partly for its own sake and partly because the products
 * filter references it - a ReferenceInput against a resource with no route is
 * a data provider error, not an empty dropdown.
 */
const filters = [<SearchInput key="q" source="q" alwaysOn placeholder="Názov, skratka alebo IČO" />];

function VerifiedField() {
  const record = useRecordContext<RaRecord & { verified: boolean | null }>();
  if (record?.verified !== true) return null;
  return <Chip size="small" color="success" variant="outlined" label="Overená" />;
}

export function OrganizationList() {
  return (
    <List filters={filters} sort={{ field: 'name', order: 'ASC' }} perPage={25} title="Organizácie">
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="name" />
        <TextField source="acronym" emptyText="—" />
        <TextField source="ico" label="IČO" emptyText="—" />
        <TextField source="icDph" label="IČ DPH" emptyText="—" />
        <VerifiedField />
      </Datagrid>
    </List>
  );
}
